import { PerformanceAnalysisboardPg } from '@models/PerformanceAnalysisboard';
import { OpportunityReviewTableContent } from '@models/OpportunityReview';
import { ExportPerformanceBySegmentResp } from '@data-visualization/performance-analysis-line-chart/Types';
import { StackedChartResp } from '@data-visualization/stacked-chart/Types';
import { CategoryLeaderboardPg } from '@models/CategoryLeaderboard';
import { ExportExploreTrendsStack } from '@data-visualization/trends-stack-chart/Types';

export const GRAND_TOTAL = 'GRAND_TOTAL';
export const TOTAL = 'TOTAL';
export const TOTAL_CAMEL_CASE = 'Total';

export const getGrandTotalValue = (): string => {
  return GRAND_TOTAL;
};

export const modifiedCLTableGrandTotalToTotalValue = (data: CategoryLeaderboardPg) => {
  return data.segmentOrPg === GRAND_TOTAL ? { ...data, segmentOrPg: TOTAL } : data;
};

export const modifiedCLSegmentsGrandTotalToTotalValue = (data: CategoryLeaderboardPg[]) => {
  return data.map((productGroup) => {
    if (productGroup.segmentOrPg === GRAND_TOTAL) return { ...productGroup, segmentOrPg: TOTAL };
    return productGroup;
  });
};

export const modifiedPATableGrandTotalToTotalValue = (data: PerformanceAnalysisboardPg) => {
  return data.segmentOrPg === GRAND_TOTAL ? { ...data, segmentOrPg: TOTAL } : data;
};

export const modifiedPAStackChartGrandTotalToTotalValue = (data: StackedChartResp[]) => {
  return data.map((stackChartKpi) => {
    if (stackChartKpi.segment === GRAND_TOTAL) return { ...stackChartKpi, segment: TOTAL };
    return stackChartKpi;
  });
};

export const modifiedPATableDoubleBarChartGrandTotalToTotalValue = (data: PerformanceAnalysisboardPg[]) => {
  return data.map((charKpi) => {
    if (charKpi.segmentOrPg === GRAND_TOTAL) return { ...charKpi, segmentOrPg: TOTAL };
    return charKpi;
  });
};

export const modifiedPAORSegmentExportGrandTotalToTotalValue = (data: ExportPerformanceBySegmentResp) => {
  const brandsKpi = data.kpiDataDto.map((brandKpi) => {
    if (brandKpi.brandName === GRAND_TOTAL) return { ...brandKpi, brandName: TOTAL };
    return brandKpi;
  });

  return { ...data, kpiDataDto: brandsKpi };
};

export const modifiedPAORSegmentExportGrandTotalToCamelCaseTotalValue = (data: ExportPerformanceBySegmentResp) => {
  const brandsKpi = data.kpiDataDto.map((brandKpi) => {
    if (brandKpi.brandName === GRAND_TOTAL) return { ...brandKpi, brandName: TOTAL_CAMEL_CASE };
    return brandKpi;
  });

  return { ...data, kpiDataDto: brandsKpi };
};

export const modifiedPAORSegmentExportStackChartGrandTotalToCamelCaseTotalValue = (data: ExportExploreTrendsStack) => {
  return data;
};

export const modifiedORTableContentGrandTotalToTotalValue = (data: OpportunityReviewTableContent) => {
  return data.segment === GRAND_TOTAL ? { ...data, segment: TOTAL } : data;
};

export const modifiedORTableContentsGrandTotalToTotalValue = (data: OpportunityReviewTableContent[]) => {
  return data.map((orSegmentKpi) => {
    if (orSegmentKpi.segment === GRAND_TOTAL) return { ...orSegmentKpi, segment: TOTAL };
    return orSegmentKpi;
  });
};
